<script>
// import store from '@state/store'
import Layout from '@layouts/guest.vue'
import { authMethods, authComputed } from '@state/helpers'
import organizationAdminsForm from '@/src/guest/components/organization-admins-form.vue'

export default {
  page: {
    meta: [{ name: 'description', content: `Organization Admins Setup` }],
  },
  components: { Layout, organizationAdminsForm },
  data() {
    return {
      username: '',
      password: '',
      authError: '',
      submitError: '',
      token: null,
      tokenValid: false,
      verifyingToken: true,
      organizationData: null,
    }
  },
  computed: {
    ...authComputed,
    currentRouteName() {
      return this.$router.currentRoute.path
    },
  },
  mounted() {
    // Get token from route params and verify it
    this.token = this.$route.params.token
    if (this.token) {
      this.verifyOrganizationToken({ token: this.token })
        .then((response) => {
          if (response.error) {
            this.submitError = response.error
            this.tokenValid = false
          } else {
            this.tokenValid = true
            // Store the organization data to pass to the form
            this.organizationData = response.organization
          }
        })
        .finally(() => {
          this.verifyingToken = false
        })
    } else {
      this.submitError = 'Invalid setup link'
      this.verifyingToken = false
    }
  },
  methods: {
    ...authMethods,
    postSubmitAdmins(params) {
      this.submitError = ''
      return this.organizationSetupAdmins({
        token: this.token,
        primaryAccountAdminName: params.primaryAccountAdminName,
        primaryAccountAdminEmail: params.primaryAccountAdminEmail,
        hasOtherAdmins: params.hasOtherAdmins,
        otherAdmins: params.otherAdmins,
      }).then((response) => {
        // Check for error responses (422 validation errors or other errors)
        if (response.error || response.errors || response.success === false) {
          // Handle validation errors from backend
          this.submitError =
            response.message || response.error || 'An error occurred'
        } else {
          // Setup complete, redirect to login or success page
          this.$router.push({ name: 'login' })
        }
      })
    },
    clearSubmitErrors() {
      this.submitError = ''
    },
  },
}
</script>

<template>
  <Layout style="height: fit-content" class="mt-20 mb-20">
    <div>
      <h1 class="home-headline1">Let's start sharing kyndfulness</h1>
      <h2 class="home-headline2"
        >Finish Setting Up Your Organization's Profile</h2
      >
      <organizationAdminsForm
        v-if="tokenValid"
        :submit-error="submitError"
        :organization-data="organizationData"
        @post-submit-admins="postSubmitAdmins"
        @clear-submit-errors="clearSubmitErrors"
      >
      </organizationAdminsForm>
    </div>
  </Layout>
</template>
